var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeOffIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88867 3.20459L17.0137 16.7046",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31946 8.70463C6.19831 10.2046 6.31957 14.2046 6.31953 14.7046C6.31948 15.539 10.7192 16.0253 13.3059 15.873M8.07053 4.4345C8.48915 3.61256 8.90878 2.71534 9.23644 1.70463C9.72261 0.204946 11.9915 1.20463 11.1813 3.70463C10.6951 5.20462 10.6951 6.70463 11.1812 7.20463C11.6673 7.70463 14.2193 6.20463 16.0422 7.70463C16.9161 8.42373 16.9169 10.9748 16.3587 13.0112",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 8.70459,
    width: 3,
    height: 6,
    rx: 0.5,
    stroke: "black",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeOffIcon);
export default __webpack_public_path__ + "static/media/LikeOffIcon.8d84aa5dc1a63642d40a3bd8b17f1e8a.svg";
export { ForwardRef as ReactComponent };